const breadCrumb = "Lotação de Servidores - Manutenção de Servidores";

const routes = [
  {
    path: "/servidor/:servidorId/contrato-de-servidores",
    name: "contrato-de-servidores",
    meta: {
      allowedPermissions: ["contratos_servidor_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ManutencaoServidores/ContratoDeServidores/ContratoDeServidoresHome.vue"
      ),
  },
  {
    path: "/servidor/:servidorId/contrato-de-servidores/novo",
    name: "contrato-de-servidores-novo",
    meta: {
      allowedPermissions: ["contratos_servidor_insert"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ManutencaoServidores/ContratoDeServidores/ContratoDeServidoresCad.vue"
      ),
  },
  {
    path: "/servidor/:servidorId/contrato-de-servidores/editar/:id",
    name: "contrato-de-servidores-editar",
    meta: {
      allowedPermissions: ["contratos_servidor_update"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ManutencaoServidores/ContratoDeServidores/ContratoDeServidoresEdit.vue"
      ),
  },
  {
    path: "/servidor/:servidorId/contrato-de-servidores/visualizar/:id",
    name: "contrato-de-servidores-visualizar",
    meta: {
      allowedPermissions: ["contratos_servidor_show"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ManutencaoServidores/ContratoDeServidores/ContratoDeServidoresShow.vue"
      ),
  },
];

export default routes;
